module.exports = __webpack_public_path__ + "media/images/menu/csm_russia-6fe2fe2381e6f0a19f18f2983be23bf5.png";